import $ from 'jquery';

$(() => {
  // Only run if it's the A/B test's results page
  if ($('.ab553').length && $('#visual-search-cards').length) {
    window.rcProps = window.rcProps || {};
    const response = window.rcProps.imageSearchResult || {};
    const selectedSegmentId = Number(window.rcProps.imageSearchSegmentId) || 0;
    const imageSearchBaseUrlBySegmentId = window.rcProps.imageSearchBaseUrlBySegmentId;

    /**
     * CARD_W / CARD_H are the rendered dimensions of each card.
     * These dimensions are lifted directly from the Figma spec.
     */
    const CARD_W = 60;
    const CARD_H = 72;
    let activeSegmentId = null;

    const $cardsContainer = $('#visual-search-cards');

    /**
     * Returns the CSS width, height, and transform needed to zoom and
     * pan a source <img> so that the bbox region fills the card.
     *
     * @param {Array}  bbox   [x1, y1, x2, y2] in source image pixels
     * @param {number} imageW Natural width of the source image
     * @param {number} imageH Natural height of the source image
     * @param {number} cardW  Rendered card width in px
     * @param {number} cardH  Rendered card height in px
     * @returns {Object}      { width, height, transform } as CSS strings
     */
    const getBboxStyles = (bbox, imageW, imageH, cardW, cardH) => {
      const x1 = bbox[0];
      const y1 = bbox[1];
      const x2 = bbox[2];
      const y2 = bbox[3];

      // How large is the region in the source image?
      const regionW = x2 - x1;
      const regionH = y2 - y1;

      // How much do we scale up the full image so this region fills the card?
      // Math.max = cover behaviour: the tighter axis drives the scale,
      // the other axis may overflow slightly — hidden by overflow: hidden.
      const scaleX = cardW / regionW;
      const scaleY = cardH / regionH;
      const scale = Math.max(scaleX, scaleY);

      // Full image rendered dimensions at this scale
      const renderedW = imageW * scale;
      const renderedH = imageH * scale;

      // Slide the image so the bbox region is centred in the card window.
      // -(x1 * scale) aligns the region's left edge to the card's left edge,
      // then we add half the leftover to centre it horizontally (and same for Y).
      const offsetX = (-(x1 * scale)) + ((cardW - (regionW * scale)) / 2);
      const offsetY = (-(y1 * scale)) + ((cardH - (regionH * scale)) / 2);

      return {
        width: `${renderedW}px`,
        height: `${renderedH}px`,
        transform: `translate(${offsetX}px, ${offsetY}px)`,
      };
    };

    const buildCardInner = (imageUrl, imgStyles, alt = '') => {
      const $img = $('<img>', {
        class: 'visual-search-results__card-img',
        src: imageUrl,
        alt,
      }).css({
        width: imgStyles.width,
        height: imgStyles.height,
        transform: imgStyles.transform,
      });

      return $('<div>', { class: 'visual-search-results__card-inner' }).append($img);
    };

    const handleCardClick = ($clicked) => {
      activeSegmentId = $clicked.data('segmentid');

      $cardsContainer.find('button.visual-search-results__card').each(function forEachCard() {
        const isActive = $(this).data('segmentid') === activeSegmentId;
        $(this)
            .toggleClass('visual-search-results__card--active', isActive)
            .attr('aria-pressed', String(isActive));
      });
    };

    const renderCards = (data) => {
      const { imageUrl, imageW, imageH, segments = [] } = data;

      $cardsContainer.empty();

      $.each(segments, (i, segment) => {
        const styles = getBboxStyles(segment.bbox, imageW, imageH, CARD_W, CARD_H);

        const $btn = $('<button>', {
          class: 'visual-search-results__card',
          type: 'button',
          'aria-label': `Filter by ${segment.segmentName}`,
          'aria-pressed': 'false',
          'data-segmentid': segment.id,
          'data-segment': segment.segmentName,
          'data-category': segment.category,
          'data-descriptions': JSON.stringify(segment.descriptions),
        }).append(buildCardInner(imageUrl, styles, segment.segmentName));

        $cardsContainer.append($btn);
      });

      const $matchedBtn = $cardsContainer
        .find('button.visual-search-results__card')
        .filter(function filterMatched() {
          return $(this).data('segmentid') === selectedSegmentId;
        })
        .first();

      // selected segment or default the first card per design spec
      const $defaultBtn = $cardsContainer.find('button.visual-search-results__card').first();
      const $targetBtn = $matchedBtn.length ? $matchedBtn : $defaultBtn;
      handleCardClick($targetBtn);
    };

    $cardsContainer.on('click', 'button.visual-search-results__card', function onCardClick() {
      const $clicked = $(this);
      handleCardClick($clicked);

      const segmentId = Number($clicked.data('segmentid')) || 0;
      const redirectUrl = `${imageSearchBaseUrlBySegmentId}${segmentId}`;
      window.location.href = redirectUrl;
    });

    // Preload the image to determine its natural dimensions before rendering cards
    const img = new Image();
    img.onload = function loadImage() {
      response.imageW = img.naturalWidth;
      response.imageH = img.naturalHeight;
      renderCards(response);
    };
    img.src = response.imageUrl;
  }
});



// WEBPACK FOOTER //
// ./styleguide/src/assets/abtests/ab553.js